module.exports = "https://static-www.niulinkcloud.com/_next/static/media/pcBanner1.7aa11651eb99bedfea976a96b59e9a5b.jpg";